import React, { Component } from 'react';
import Breadcrumb from "../common/breadcrumb";
import blog2 from "../../assets/images/blog2.jpg"
import blog3 from "../../assets/images/blog3.jpg"
import blog1 from "../../assets/images/blog1.jpg"
import example from "../../assets/images/example.jpg"
import download1 from "../../assets/images/download (1).png"
import download2 from "../../assets/images/download (2).png"
import download3 from "../../assets/images/download (3).png"
import download4 from "../../assets/images/download (4).png"
import download5 from "../../assets/images/download (5).png"
import { withRouter } from 'react-router-dom';

class BlogDetails extends Component {

    constructor(props) {
        super(props)
        this.state = {
            id: ''
        }

    }

    async componentDidMount(params) {
        const searchParams = new URLSearchParams(this.props.location.search);
        const id = searchParams.get('id');
        this.setState({ id: id });
    };
    async componentDidUpdate(prevProps){
        if (this.props.location.search !== prevProps.location.search) {
        const searchParams = new URLSearchParams(prevProps.history.location.search);
        const id = searchParams.get('id');
        this.setState({ id: id });
        }
     
    }
    render() {


        return (
            <div>
                <Breadcrumb title={'بلاگ'} />


                {/*Blog Details section*/}
                {this.state.id === '1' && <section className="blog-detail-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 blog-detail">
                                <img src={blog3} style={{ width: '1370px', height: '385px' }} className="img-fluid" alt="" />
                                <h3>اتصال اسپاتیفای به اینترنت بدون vpn (فیلترشکن)</h3>
                                <ul className="post-social">
                                    <li>27 دی 1402</li>
                                    <li><i className="fa  fa-thumbs-o-up"></i> 5</li>
                                    <li><i className="fa  fa-thumbs-o-down"></i> 5</li>
                                    <li><i className="fa fa-comments"></i> 10</li>
                                </ul>
                                <div >
                                    <p>اتصال اسپاتیفای به اینترنت بدون vpn (فیلترشکن) علاوه بر سهولت استفاده از این سرویس باعث جلوگیری از بلاک شدن اکانت توسط اسپاتیفای می شود چرا که استفاده از vpn ها به دلیل آی پی های متغیری که در اختیار شما قرار می دهند مورد تایید شرکت نیستند.

                                        اگر توجه کرده باشید اخیرا اسپاتیفای محدودیت های جدیدی گذاشته که با توجه به اتصال به اینترنت باز هم پیغام خطای وصل نبودن اینترنت یا No internet Connection دریافت می کنید.

                                        برای حل این مشکل، با ما همراه باشید.</p>
                                </div>

                            </div>
                        </div>
                        <div className="row section-b-space blog-advance">
                            <div className="col-lg-6">
                                <img src={download1} className="img-fluid" alt="" style={{ width: '100px' }} />
                            </div>
                            <div className="col-lg-6">
                                <img src={download3} className="img-fluid" alt="" style={{ width: '100px' }} />
                            </div>
                            <div className="col-lg-6">
                                <h5>راه حل برای ویندوز :</h5>
                                <ul>
                                    <li> از منوی Start وارد کنترل پنل (Control Panel) شوید.</li>
                                    <li> روی گزینه Network and Internet کلیک کنید.</li>
                                    <li> روی گزینه Change Adapter Settings کلیک کنید.</li>
                                    <li>روی شبکه وای‌فای یا شبکه LAN که به آن متصل هستید راست کلیک کنید و سپس Properties را انتخاب کنید.</li>
                                    <li>گزینه Internet Protocol Version 4 را انتخاب کنید.</li>
                                    <li>دکمه Properties را بزنید.</li>
                                    <li> اگر نشانی DNS وجود دارد آن را جایی یادداشت کنید و برای مراجعات بعدی نگه دارید. سپس آنها را پاک کنید.</li>
                                    <li> نشانی ۱۷۸.۲۲.۱۲۲.۱۰۰ و ۱۸۵.۵۱.۲۰۰.۲ را در بخش‌های مربوط به DNS وارد کنید. (از سایت www.shecan.ir هم میتوانید این اطلاعات را اخذ نمایید)</li>
                                    <img src={example} className="img-fluid" alt="" />
                                    <li> دکمه OK را بزنید و پنجره را ببندید</li>
                                    <li>مرورگر خود را ری‌استارت نمایید.</li>
                                </ul>
                            </div>
                            <div className="col-lg-6">
                                <h5>راه حل برای آیفون iPhone / IOS :</h5>
                                <ul>
                                    <li> از منوی Start وارد کنترل پنل (Control Panel) شوید.</li>
                                    <li> روی گزینه Network and Internet کلیک کنید.</li>
                                    <li> روی گزینه Change Adapter Settings کلیک کنید.</li>
                                    <li>روی شبکه وای‌فای یا شبکه LAN که به آن متصل هستید راست کلیک کنید و سپس Properties را انتخاب کنید.</li>
                                    <li>گزینه Internet Protocol Version 4 را انتخاب کنید.</li>
                                    <li>دکمه Properties را بزنید.</li>
                                    <li> اگر نشانی DNS وجود دارد آن را جایی یادداشت کنید و برای مراجعات بعدی نگه دارید. سپس آنها را پاک کنید.</li>
                                    <li> نشانی ۱۷۸.۲۲.۱۲۲.۱۰۰ و ۱۸۵.۵۱.۲۰۰.۲ را در بخش‌های مربوط به DNS وارد کنید. (از سایت www.shecan.ir هم میتوانید این اطلاعات را اخذ نمایید)</li>
                                    <li> دکمه OK را بزنید و پنجره را ببندید</li>
                                    <li>مرورگر خود را ری‌استارت نمایید.</li>
                                </ul>
                            </div>


                        </div>
                        <div className="row section-b-space blog-advance">
                            <div className="col-lg-6">
                                <img src={download2} className="img-fluid" alt="" style={{ width: '100px' }} />
                            </div>
                            <div className="col-lg-6">
                                <img src={download4} className="img-fluid" alt="" style={{ width: '100px' }} />
                            </div>


                            <div className="col-lg-6">
                                <h5>راه حل برای اندروید :</h5>
                                <h6>لینک دانلود مستقیم اپلیکیشن شکن برای اندروید</h6>
                            </div>
                            <div className="col-lg-6">
                                <h5>راه حل برای پلی استیشن ۴ :</h5>
                                <ul>
                                    <li> از منوی Start وارد کنترل پنل (Control Panel) شوید.</li>
                                    <li> روی گزینه Network and Internet کلیک کنید.</li>
                                    <li> روی گزینه Change Adapter Settings کلیک کنید.</li>
                                    <li>روی شبکه وای‌فای یا شبکه LAN که به آن متصل هستید راست کلیک کنید و سپس Properties را انتخاب کنید.</li>
                                    <li>گزینه Internet Protocol Version 4 را انتخاب کنید.</li>
                                    <li>دکمه Properties را بزنید.</li>
                                    <li> اگر نشانی DNS وجود دارد آن را جایی یادداشت کنید و برای مراجعات بعدی نگه دارید. سپس آنها را پاک کنید.</li>
                                    <li> نشانی ۱۷۸.۲۲.۱۲۲.۱۰۰ و ۱۸۵.۵۱.۲۰۰.۲ را در بخش‌های مربوط به DNS وارد کنید. (از سایت www.shecan.ir هم میتوانید این اطلاعات را اخذ نمایید)</li>
                                    <li> دکمه OK را بزنید و پنجره را ببندید</li>
                                    <li>مرورگر خود را ری‌استارت نمایید.</li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="row section-b-space">
                            <div className="col-sm-12">
                                <div className='box'>
                                    <h3>اکانت پریمیوم (بدون محدودیت اسپایتفای)</h3>
                                    <p>این سرویس پلن رایگان و غیر رایگان دارد و شما با استفاده از پلن رایگان به قابلیت‌های محدودی از سرویس همراه با پخش تبلیغات آزاردهنده دسترسی دارید اما با خرید پلن پریمیوم قابلیت‌های بسیار کاربردی برای شما فعال می‌شود.

                                        شما با خرید اکانت اسپاتیفای پرمیوم می‌توانید لیست آهنگ (پلی لیست) مورد علاقه خودتان را در فضای ابری و سرورهای این شرکت داشته باشید و آن‌ها را بر روی دستگاه هر دستگاهی که تمایل داشته باشید دانلود کرده و در هم هر زمان و هر مکانی به آنها دسترسی داشته باشید.

                                        دقت داشته باشید که سرویس اسپاتیفای پریمیوم که در سایت ایزیکارت ۷۲۴ ارائه می شود سرویس گیفت کارت هست که امکان خرید اکانت کشور دلخواه را به شما می دهد و محدودیت های سرویس فمیلی را ندارد. پس با خیال راحت از شنیدن موسیقی نامحدود لذت ببرید.</p>
                                </div>
                            </div></div> */}

                        <div className="row section-b-space">
                            <div className="col-sm-12">
                                <ul className="comment-section">
                                    <li>
                                        <div className="media">
                                            <img src={download5} alt="Generic placeholder image" />
                                            <div className="media-body">
                                                <h3>اکانت پریمیوم (بدون محدودیت اسپایتفای)</h3>
                                                <p>این سرویس پلن رایگان و غیر رایگان دارد و شما با استفاده از پلن رایگان به قابلیت‌های محدودی از سرویس همراه با پخش تبلیغات آزاردهنده دسترسی دارید اما با خرید پلن پریمیوم قابلیت‌های بسیار کاربردی برای شما فعال می‌شود.

                                                    شما با خرید اکانت اسپاتیفای پرمیوم می‌توانید لیست آهنگ (پلی لیست) مورد علاقه خودتان را در فضای ابری و سرورهای این شرکت داشته باشید و آن‌ها را بر روی دستگاه هر دستگاهی که تمایل داشته باشید دانلود کرده و در هم هر زمان و هر مکانی به آنها دسترسی داشته باشید.

                                                    دقت داشته باشید که سرویس اسپاتیفای پریمیوم که در سایت ایزیکارت ۷۲۴ ارائه می شود سرویس گیفت کارت هست که امکان خرید اکانت کشور دلخواه را به شما می دهد و محدودیت های سرویس فمیلی را ندارد. پس با خیال راحت از شنیدن موسیقی نامحدود لذت ببرید.</p>
                                                {/* <div className='text-left'>
                                                    <a href="#" className="btn btn-solid ">اکنون خرید کنید</a>
                                                </div> */}

                                            </div>
                                        </div>
                                    </li>
                                    {/* <li>
                                        <div className="media">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/2.jpg`} alt="Generic placeholder image" />
                                            <div className="media-body">
                                                <h6>Mark Jecno <span>( 12 Jannuary 2018 at 1:30AM )</span></h6>
                                                <p>Donec rhoncus massa quis nibh imperdiet dictum. Vestibulum id est
                                                    sit amet felis fringilla bibendum at at leo. Proin molestie ac
                                                    nisi eu laoreet. Integer faucibus enim nec ullamcorper tempor.
                                                    Aenean nec felis dui. Integer tristique odio mi, in volutpat
                                                    metus posuere eu. Aenean suscipit ipsum nunc, id volutpat lorem
                                                    hendrerit ac. Sed id elit quam. In ac mauris arcu. Praesent eget
                                                    lectus sit amet diam vestibulum varius. Suspendisse dignissim
                                                    mattis leo, nec facilisis erat tempor quis. Vestibulum eu
                                                    vestibulum ex. </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="media">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/20.jpg`} alt="Generic placeholder image" />
                                            <div className="media-body">
                                                <h6>Mark Jecno <span>( 12 Jannuary 2018 at 1:30AM )</span></h6>
                                                <p>Donec rhoncus massa quis nibh imperdiet dictum. Vestibulum id est
                                                    sit amet felis fringilla bibendum at at leo. Proin molestie ac
                                                    nisi eu laoreet. Integer faucibus enim nec ullamcorper tempor.
                                                    Aenean nec felis dui. Integer tristique odio mi, in volutpat
                                                    metus posuere eu. Aenean suscipit ipsum nunc, id volutpat lorem
                                                    hendrerit ac. Sed id elit quam. In ac mauris arcu. Praesent eget
                                                    lectus sit amet diam vestibulum varius. Suspendisse dignissim
                                                    mattis leo, nec facilisis erat tempor quis. Vestibulum eu
                                                    vestibulum ex. </p>
                                            </div>
                                        </div>
                                    </li> */}

                                </ul>
                            </div>
                        </div>
                        {/* <div className="row blog-contact">
                            <div className="col-sm-12">
                                <h2>ارسال دیدگاه</h2>
                                <form className="theme-form">
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <label htmlFor="name">نام</label>
                                            <input type="text" className="form-control" id="name"
                                                placeholder="نام خود را وارد کنید" required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="email">ایمیل</label>
                                            <input type="text" className="form-control" id="email" placeholder="ایمیل"
                                                required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="exampleFormControlTextarea1">متن</label>
                                            <textarea className="form-control" placeholder="متن ..."
                                                id="exampleFormControlTextarea1" rows="6"></textarea>
                                        </div>
                                        <div className="col-md-12 text-left">
                                            <button className="btn btn-solid float-left" type="submit">ارسال دیدگاه</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </section>}

                {this.state.id === '3' && <section className="blog-detail-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 blog-detail">
                                <img src={blog1} style={{ width: '1370px', height: '385px' }} className="img-fluid" alt="" />
                                <h3>
ویزا کارت چیست و انواع کارت های آن کدام اند و چه کاربردی دارند؟</h3>
                                <ul className="post-social">
                                    <li>27 دی 1402</li>
                                    <li><i className="fa  fa-thumbs-o-up"></i> 5</li>
                                    <li><i className="fa  fa-thumbs-o-down"></i> 5</li>
                                    <li><i className="fa fa-comments"></i> 10</li>
                                </ul>
                                <div >
                                    <p>ویزا کارت یک سیستم پرداخت بانکی است که به وسیله ی آن می توانید از هزاران فروشگاه اینترنتی و فیزیکی که ویزا کارت می پذیرند خرید و از خدماتشان استفاده کنید. برای مثال اگر قصد شرکت در یک آزمون بین المللی مانند تافل، آیلتس یا… داشته باشید برای ثبت نام در آن و پرداخت هزینه های مربوط به ثبت نام می بایست بتوانید از یک روش پرداخت بین المللی استفاده کنید. حتی بسیاری از وبسایت هایی که برای مدت کوتاهی خدمات رایگان به کاربران خود ارائه می کنند برای ثبت نام و دریافت خدمات از شما می خواهند که اطلاعات یک کارت اعتباری معتبر را وارد کنید. متاسفانه به دلیل وجود تحریم ها، کاربران ایرانی با قابلیت های بسیار زیاد ویزا کارت به عنوان یک روش پرداخت بین المللی آشنا نیستند و یکی از مهم ترین دلایل آن را هم می توان عدم سرویس دهی ویزا و کمپانی های مشابه مانند مستر کارت به ایران به دلیل وجود تحریم ها دانست. در این مقاله آموزشی سعی داریم اطلاعات دقیق و کاملی درباره ویزا کارت و تفاوت های آن با دیگر کارت های بانکی ارائه کنیم.</p>
                               <br></br>
                               <p>این شرکت در سال ۱۹۵۶ در ایالت کالیفرنیای آمریکا برای اولین بار فعالیت خود را آغاز کرد و در حال حاضر در سراسر جهان و در بسیاری از کشور ها (بیش از ۱۴۰ کشور) شعبه دارد و یک شرکت چند ملیتی می باشد.

چه شما دارای یک کسب و کار اینترنتی یا فیزیکی و چه یک کاربر عادی باشید که قصد پرداخت مبلغ به فرد یا نهادی را دارد، می توانید از خدمات سیستم پرداخت ویزا کارت استفاده کنید. انواع ویزا کارت به طور خلاصه شامل کارت های اعتباری (Credit Card)، کارت بانکی (Debit Card) و کارت های پیش پرداخت (Prepaid Card)  است.</p>
                                </div>

                            </div>
                        </div>
                        <div className="row section-b-space blog-advance mt-3">
                         
                            <div className="col-lg-6">
                                <h5>ویزا کارت چیست و انواع کارت های آن کدام اند و چه کاربردی دارند؟</h5>
                                <ul>
                                    <li>خرید حضوری در فروشگاه های فیزیکی از طریق دستگاه های کارت خوان (POS)</li>
                                    <li>دریافت وجه دستی از طریق دستگاه های خودپرداز (ATM)</li>
                                    <li>پرداخت وجه آنلاین در وبسایت های فروشگاهی برای خرید یک کالا یا خدمات</li>
                                    <li>انتقال وجه برای افراد دیگر (آشنایان، خانواده و…)</li>
                              
                                </ul>
                            </div>
                         


                        </div>
                  

                        
                        {/* <div className="row section-b-space">
                            <div className="col-sm-12">
                                <div className='box'>
                                    <h3>اکانت پریمیوم (بدون محدودیت اسپایتفای)</h3>
                                    <p>این سرویس پلن رایگان و غیر رایگان دارد و شما با استفاده از پلن رایگان به قابلیت‌های محدودی از سرویس همراه با پخش تبلیغات آزاردهنده دسترسی دارید اما با خرید پلن پریمیوم قابلیت‌های بسیار کاربردی برای شما فعال می‌شود.

                                        شما با خرید اکانت اسپاتیفای پرمیوم می‌توانید لیست آهنگ (پلی لیست) مورد علاقه خودتان را در فضای ابری و سرورهای این شرکت داشته باشید و آن‌ها را بر روی دستگاه هر دستگاهی که تمایل داشته باشید دانلود کرده و در هم هر زمان و هر مکانی به آنها دسترسی داشته باشید.

                                        دقت داشته باشید که سرویس اسپاتیفای پریمیوم که در سایت ایزیکارت ۷۲۴ ارائه می شود سرویس گیفت کارت هست که امکان خرید اکانت کشور دلخواه را به شما می دهد و محدودیت های سرویس فمیلی را ندارد. پس با خیال راحت از شنیدن موسیقی نامحدود لذت ببرید.</p>
                                </div>
                            </div></div> */}

                       
                        {/* <div className="row blog-contact">
                            <div className="col-sm-12">
                                <h2>ارسال دیدگاه</h2>
                                <form className="theme-form">
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <label htmlFor="name">نام</label>
                                            <input type="text" className="form-control" id="name"
                                                placeholder="نام خود را وارد کنید" required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="email">ایمیل</label>
                                            <input type="text" className="form-control" id="email" placeholder="ایمیل"
                                                required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="exampleFormControlTextarea1">متن</label>
                                            <textarea className="form-control" placeholder="متن ..."
                                                id="exampleFormControlTextarea1" rows="6"></textarea>
                                        </div>
                                        <div className="col-md-12 text-left">
                                            <button className="btn btn-solid float-left" type="submit">ارسال دیدگاه</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </section>}

                {this.state.id === '2' && <section className="blog-detail-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 blog-detail">
                                <img src={blog2} style={{ width: '1370px', height: '385px' }} className="img-fluid" alt="" />
                                <h3>چگونه پلی لیست و آهنگها را در اسپاتیفای انتقال دهیم؟</h3>
                                <ul className="post-social">
                                    <li>27 دی 1402</li>
                                    <li><i className="fa  fa-thumbs-o-up"></i> 5</li>
                                    <li><i className="fa  fa-thumbs-o-down"></i> 5</li>
                                    <li><i className="fa fa-comments"></i> 10</li>
                                </ul>
                                <div >
                                    <p>بعضی وقت ها میخوام آهنگ های پلی لیست، آهنگ‌ها، آلبوم ها و آرتیست هایی را که تا الان نگهداری کردیم را به اکانتی دیگری انتقال بدهیم.</p>
                                </div>

                            </div>
                        </div>
                        <div className="row section-b-space blog-advance">
                         
                            <div className="col-lg-6">
                                <ul>
                                    <li>ابتدا وارد سایت بشید.</li>
                                    <li>در قسمت بالا سمت چپ کادری که old user نام دارد اکانت قبلی خود را نوشته و وارد شوید.</li>
                                    <li>پس از ورود، در قسمت پایین تمام آهنگ ها، پلی لیست ها و … برای شما نمایش داده میشود.</li>
                                    <li>سپس در یک صفحه جداگانه وارد سایت اسپاتیفای شوید و از آنجا خارج (Log out) شوید.</li>
                                    <li>مجددا در قسمت بالا سمت راست این سایت و در کادر new user اکانت جدیدتون رو وارد کنید.</li>
                                    <li>پس از وارد شدن تمام اطلاعات اکانت قبلی رو با انتخاب گزینه‌ی transfer all به اکانت جدید خود انتقال دهید.</li>
                                    <li>تصویر زیر برای درک بهتر مطلب می باشد.</li>
                                 
                                    <img src={example} className="img-fluid" alt="" />
                                  
                                </ul>
                        </div>


                        </div>
                     
                    

                 
                        {/* <div className="row blog-contact">
                            <div className="col-sm-12">
                                <h2>ارسال دیدگاه</h2>
                                <form className="theme-form">
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <label htmlFor="name">نام</label>
                                            <input type="text" className="form-control" id="name"
                                                placeholder="نام خود را وارد کنید" required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="email">ایمیل</label>
                                            <input type="text" className="form-control" id="email" placeholder="ایمیل"
                                                required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="exampleFormControlTextarea1">متن</label>
                                            <textarea className="form-control" placeholder="متن ..."
                                                id="exampleFormControlTextarea1" rows="6"></textarea>
                                        </div>
                                        <div className="col-md-12 text-left">
                                            <button className="btn btn-solid float-left" type="submit">ارسال دیدگاه</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </section>}

            </div>
        )
    }
}

export default withRouter(BlogDetails)